import { Container } from "./styleLoading";

const Loading = () => {
  return (
    <Container>
      <img
        src={"https://sli.lbca.com.br/wp-content/uploads/2023/11/lbca-logo.png"}
        alt="Logo LBCA"
      />
      <h1>Carregando...</h1>
    </Container>
  );
};

export default Loading;
